import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { capture } from "@/lib/posthog";
import { onboardingKeys } from "@/lib/query-keys";
import { useUnlockContracting } from "@/hooks/mutations/useUnlockContracting";

/**
 * Desbloquea una obra desde el onboarding con 1 vista. La fila sigue cargando
 * hasta que vuelve la vista previa ya abierta, no solo hasta que responde el
 * desbloqueo.
 */
export function useOnboardingUnlock(segment: "supplier" | "contractor") {
  const qc = useQueryClient();
  const unlock = useUnlockContracting();
  const [unlockingId, setUnlockingId] = useState<number | null>(null);

  function unlockWork(contractingId: number, position: number) {
    capture("onboarding_unlock_clicked", { segment, position });
    setUnlockingId(contractingId);
    unlock.mutate(
      { contracting_id: contractingId },
      {
        onSuccess: async () => {
          await qc.invalidateQueries({ queryKey: onboardingKeys.all });
          setUnlockingId(null);
        },
        onError: () => setUnlockingId(null),
      },
    );
  }

  return { unlockingId, unlockWork };
}
